/** A complete, well-formed 510(k) number — the ONE definition gating both the
 *  reflect-back lookup query (hooks.ts) and the dispatch form's validity /
 *  payload (dispatch/us.tsx). Lives in its own pure module so tests that mock
 *  the hooks module don't lose it. */
export const K_NUMBER_RE = /^K\d{6}$/;

/** A plausible EU Basic UDI-DI — the EU twin of K_NUMBER_RE. No fixed
 *  format across issuing agencies; existence is the real check (EUDAMED). */
export const EU_UDI_RE = /^[A-Z0-9]{4,32}$/i;
